import React from 'react';
import { Button, Row, Col } from 'reactstrap';

import PropTypes from 'prop-types';
import qs from 'qs';
import Link from 'next/link';
import getAxiosInstance from '../../config/api';
import { ArticleCarouselCard } from './ArticleCard';
import Carousel, { CarouselSlide } from '../Carousel';

export const loadCarouselArticles = async (config, req) => {
  const axiosInstance = await getAxiosInstance(req);
  const query = qs.stringify({
    query: config.query,
    pageSize: config.pageSize || 8,
  });
  const response = await axiosInstance.get(`/public/articles?${query}`);
  return response.data.rows;
};

function ArticleCarousel({ carousel }) {
  const { articles = [], config } = carousel;

  const { query, name } = config;

  // bug fix because qs isnt encoding correctly, which makes a call become 2 querys or more if a '&' character is in productCategory
  const relatedArticlesQuery = qs
    .stringify(query)
    .replaceAll('%', '%25')
    .replaceAll('=', '%3D')
    .replaceAll('&', '%26');
  const minHeight = '330px';
  return (
    <>
      {articles.length > 0 && (
        <div style={{ minHeight }} className="article-carousel">
          <Row className="mt-3 justify-content-between">
            <Col xs={12} className="d-flex justify-content-between">
              <h4 className="d-inline ps-2"> {name}</h4>

              {name !== 'Liknande artiklar' && (
                <span className="text-md-end">
                  {articles.length > 4 && (
                    <Link
                      className="text-muted p-0"
                      href={`/articles?querySpecification=${relatedArticlesQuery}`}
                    >
                      <Button
                        color="link"
                        className="text-muted d-none d-sm-inline"
                      >
                        Se fler artiklar &gt;&gt;
                      </Button>
                      <Button color="link" className="text-muted d-sm-none">
                        Se mer &gt;&gt;
                      </Button>
                    </Link>
                  )}
                </span>
              )}
            </Col>
          </Row>

          <div>
            <Carousel
              key={config.id || carousel.id || 'ArticleCarouselKey'}
              id={config.id || carousel.id || 'ArticleCarouselId'}
              className="p-2"
              minHeight={minHeight}
            >
              {articles.length &&
                articles.map(item => (
                  <CarouselSlide key={item.id}>
                    <ArticleCarouselCard article={item} />
                  </CarouselSlide>
                ))}
            </Carousel>
          </div>
        </div>
      )}
    </>
  );
}

ArticleCarousel.defaultProps = {
  leftAdjustTitle: 'ps-5',
};

ArticleCarousel.propTypes = {
  carousel: PropTypes.object.isRequired,
  leftAdjustTitle: PropTypes.string,
};

export default ArticleCarousel;
